import React, { FC } from 'react'
import AddNewCompany from 'containers/Companies/AddNewCompany'

const NewCompanyPage: FC = () => <AddNewCompany />

export default NewCompanyPage
